import type { PopupWindowFeatures } from 'oidc-client-ts';

export const popupWindowFeature = 'location=no,toolbar=no,width=500,height=500,left=100,top=100';
export const popupTarget = 'wb_login_ui';
export const authServiceResponseType = 'code';
export const logoutPopupTarget = 'wb_logout_ui';
export const isNewAuthUser = 'is_new_auth_user';
export const usernameCookieName = 'Username';
export const refreshtokenCookieName = 'refreshtoken';
export const accesstokenCookieName = 'accesstoken';
export const authV1GrantType = 'em_refresh_token';
export const authV2GrantType = 'refresh_token';
export const silentRenewIntervalKey = 'silent_renew_interval';
export const logoutIframeId = 'silent-logout-iframe';
export const oidcSettingsStorageId = 'wb_oidc_settings';

export const authPopupWindowFeatures: PopupWindowFeatures = {
    location: false,
    toolbar: false,
    width: 500,
    height: 500,
    left: 100,
    top: 100
};